export enum CountryGroupSortProperty {
  Name = 'name',
}
